<template>

<div>

	<div class="page-header">
		<h1><lang labelKey="HEADER_LABELS"></lang></h1>
	</div>

	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<div class="columns" v-if="!isLoading">

		<div class="col-main">

			<template v-if="!isLoading">
				<v-client-table name="tblLabels" :data="labels" :columns="tblColumns" :options="tblOptions" class="tblLabels noFirstColumn">

					<template slot="value" slot-scope="props">
						<input type="text" class="input is-normal" :value="props.row.value" @change="labelUpdate(props.row.id, $event)" />
					</template>

					<template slot="delete" slot-scope="props">
						<pop-confirm :content="$t('CONFIRMATION-DELETE_LABEL')" icon="question-circle-o" :on-ok="function() { labelDelete(props) }">
							<span class="icon is-small"><i class="icon-ak-entfernen"></i></span>
						</pop-confirm>
					</template>

				</v-client-table>

			</template>

		</div>

		<div class="col-aside">

		</div>

	</div>

</div>
</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

export default {
	name: 'labels',
	data() {
		return {
			isLoading: true,
			labels: [],
			tblColumns: ['name', 'value', 'delete'],
			tblOptions: {
				saveState: true,
				perPage: 25,
				orderBy: {
					ascending: true,
					column: 'name'
				},
				headings: {
					name: function(h) {
						return <lang labelKey="LABELS_TBL_HEADER-LABELKEY"></lang>
					},
					value: function(h) {
						return <lang labelKey="LABELS_TBL_HEADER-LABEL"></lang>
					},
					delete: function(h) {
						return <lang labelKey="LABELS_TBL_HEADER-DELETE"></lang>
					}
				},
				filterByColumn: true,
				filterable: ['name', 'value'],
				sortable: ['name', 'value'],
				sortIcon: {
					base:'fa',
					up:'fa-sort-up',
					down:'fa-sort-down',
					is:'fa-sort'
				},
				texts: {
					filter: 'Filter Ergebnisse:',
					filterPlaceholder: 'Suche',
					limit: 'Einträge pro Seite',
					noResults: 'keine passenden Einträge gefunden',
					count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
				},
				pagination: {
					chunk: 5
				},
				skin: 'table is-striped is-hoverable is-fullwidth',
			}
		}
	},

	mounted() {
		this.fetchData();
	},

	updated() {

	},

	methods: {

		fetchData() {

            this.isLoading = true;
            var self = this;
			var apiURL = this.$config.api + 'label';

            // fetch data
            this.axios.get(apiURL)
                .then(function(response) {
					self.labels = response.data.label;
                    self.isLoading = false;
                }).catch(function(error) {
                    self.isLoading = false;
                    console.log('Error: ', error.message);
                });

        },

		labelUpdate(id, e) {

			if(id == "" || e.target.value == "") {
				return;
			}

			var self = this;
			var apiURL = this.$config.api + 'label/'+id;
			var saveObj = {
				"id": id,
				"app": "cms",
				"value": e.target.value
			}

			this.axios.put(apiURL, saveObj)
				.then(function(response) {
					// show success notify
					self.$notify.success({content: 'Erfolgreich gespeichert!'});

					/*
					self.$store.dispatch('fetchLabels', self.$store.state.currentLang).then(() => {

					});
					*/
				})
				.catch(function(error) {

					// show success notify
					self.$notify.open({content: 'Fehler beim Speichern der Daten: ' + error.message, type: 'danger'});
				});

		},

		labelDelete(props) {

			var self = this;
			var labelId = props.row.id;

            // fetch data
            this.axios.delete(this.$config.api + 'label/'+props.row.id)
                .then(function(response) {

					// find the label and remove it from the labels array
					for(var i =0; i < self.labels.length; i++) {
						if(self.labels[i].id == labelId) {
							self.labels.splice(i, 1);
						}
					}

					self.$notify.success({content: self.$t('MSG-SUCCESS-LABEL_SCCESSFULLY_DELETED')});

                }).catch(function(error) {
                    self.isLoading = false;
                    console.log('Error: ', error.message);
                });

		},


	}
}
</script>


<style>

.tblLabels th:first-child {
	width: 40%;
}
.tblLabels thead th:last-child {
    width: 100px;
    text-align: center;
}
.tblLabels td:last-child {
    text-align: center;
}

</style>
